import makeStyles from "utils/makeStyles";

export default makeStyles((theme) => ({
  root: {
    height: 0,
  },
  label: {
    fontSize: 12,
    lineHeight: "13px",
    color: "rgba(0, 0, 0, 0.54)",
    fontWeight: 700,
  },
  listItem: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingLeft: theme.spacing(1),
    paddingRight: "0",
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    "&:hover": {
      background: "#eeeeee",
    },
    [theme.breakpoints.down(768)]: {
      alignItems: "center",
      flexDirection: "column",
      textAlign: "center",
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1),
    },
  },
  list: {
    // boxShadow: "1px 0px 6px 0px #9e9e9e"
    height: "calc(100vh - 73px)",
    overflowY: "auto",
  },
  activeListItem: {
    color: `${theme.palette.primary.main}!important`,
    fontWeight: "bold",
  },
  icon: {
    marginTop: "10px",
    fontSize: 22,
    color: "rgba(0, 0, 0, 0.54)",
  },
  listItemLink: {
    textDecoration: "none !important",
    border: "5px solid whit",
  },
  navbarContent: {
    width: "100%",
    height: 64,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  navLogoWrapper: {
    // width: 178,
    // height: 74,
    // backgroundColor:"red",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  navLogo: (props) => ({
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    height: "70px",
    width: "90%",
    backgroundImage: `url(${
      props.appLogo
        ? props.appLogo
        : props.hostConfig.navLogo ||
          props.currentUser.company.logo ||
          props.hostConfig.navLogo
    })`,
  }),
  logo: {
    // marginRight: "15px",
    // marginLeft: "15px",
    // maxWidth: '200px',
    padding: 5,
    width: 180,
    height: 70,
  },
  defaultLogo: {
    width: "100px",
    marginLeft: 25,
  },
  listItemIconStyle: {
    justifyContent: "center",
  },
  listItemIconContainer: {
    width: 24,
    height: 24,
    overflow: "hidden",
  },
  sidebarIcon: {
    width: "100%",
    objectFit: "contain",
  },
  activeList: (props) => ({
    fontWeight: "bold",
    color: props.theme.palette.primary.main
      ? props.theme.palette.primary.main
      : props.hostConfig.themeColor,
  }),
  inactiveList: {
    color: "#606C80",
    fontWeight: "normal",
  },
  bold: {
    fontWeight: "bold",
  },
  normal: {
    fontWeight: "normal",
  },
  drawer: {
    width: 212,
    boxShadow: "2px 4px 12px rgba(96, 108, 128, 0.12)",
    borderBottom: "none",
    flexShrink: 0,
    whiteSpace: "nowrap",
    paddingBottom: 25,
    zIndex: 1,
    "&::-webkit-scrollbar": {
      display: "none",
    },
    msOverflowStyle: "none",
    [theme.breakpoints.down(768)]: {
      width: 80,
    },
  },
  drawerOpen: {
    width: 212,
    zIndex: 1,
    paddingBottom: 25,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerClose: {
    zIndex: 1,
    paddingBottom: 25,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
}));
